// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3lcdU","colMin":"styles_colMin__2t_KC","colCheckbox":"styles_colCheckbox__1d74b"};